import * as MutationTypes from "../mutation_types"
import { State, AuthHeaders, YearlySummaryRow } from "../store_types"
import { callYearlySummariesAPI, callDownloadYearlySummaryAPI } from "../../api/yearly_summaries"
import { AxiosResponseHeaders } from "axios"
import { saveAs } from "file-saver"

const getDefaultState = () => {
  return {
    yearlySummaryRows : []
  }
}

const yearlySummaries = {
  state: () => getDefaultState(),

  getters: {
    YearlySummaryRows (state : State) {
      return state.yearlySummaryRows
    },
  },

  actions: {
    fetchYearlySummary({ commit, getters }: { commit: (mutationType:string, result: AxiosResponseHeaders | Array<YearlySummaryRow>) => void, getters: { [authHeaders: string]: AuthHeaders | number | Date }}){
      if(getters.selectedCorporationId === null) return
      commit(MutationTypes.ASSIGN_YEARLY_SUMMARY, [])
      return new Promise<void>((resolve, reject) => {
        // 指定企業の登録数取得
        callYearlySummariesAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            startDate: getters.selectedYearlySummaryStartDate as Date,
            endDate: getters.selectedYearlySummaryEndDate as Date,
          },
          // Success
          (headers: AxiosResponseHeaders, yearlySummaryRows: Array<YearlySummaryRow>) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_YEARLY_SUMMARY, yearlySummaryRows)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    downloadYearlySummary({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders) => void, getters: { [key: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callDownloadYearlySummaryAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            startDate: getters.selectedYearlySummaryStartDate as Date,
            endDate: getters.selectedYearlySummaryEndDate as Date,
          },
          // Success
          (headers: AxiosResponseHeaders, csvData: Blob) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            saveAs(csvData, "年度別データ.csv")
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },
  },

  mutations: {
    [MutationTypes.ASSIGN_YEARLY_SUMMARY](state: State, yearlySummaryRows: Array<YearlySummaryRow>) {
      state.yearlySummaryRows = yearlySummaryRows
    },
  },
}

export default yearlySummaries
